import React from "react";

// reactstrap components
import {
  Button,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

function FooterSocial() {
  return (
    <>
      <footer className="footer">
        <Container>
          <div className="content">
            <Row>
              <Col md="3">
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <h5>Escape to Infinity Collection</h5>
                </a>
                <p>
                  Tenfinney.com
                </p>
              </Col>
              <Col md="2">
                <h5>Basics</h5>
                <ul className="links-vertical">
                  {/* <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Blog
                    </a>
                  </li>
                  <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      About Us
                    </a>
                  </li> */}
                  <li>
                    <a href="https://ipfs.infura.io/ipfs/QmRu3UCuioKp3SayzNvq6MHxLqWu26by3sQqvzHEn3mWXU" onClick={(e) => e.preventDefault()}>
                    Self-executing demo
                    </a>
                  </li>
                  <li>
                    <a href="/contact-us" onClick={(e) => e.preventDefault()}>
                      Contact Us
                    </a>
                  </li>
                </ul>
              </Col>
              {/* <Col md="2">
                <h5>Market</h5>
                <ul className="links-vertical">
                  <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Sales FAQ
                    </a>
                  </li>
                  <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      How to Register
                    </a>
                  </li>
                  <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Sell Goods
                    </a>
                  </li>
                  <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Receive Payment
                    </a>
                  </li>
                  <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Transactions Issues
                    </a>
                  </li>
                </ul>
              </Col> */}
              <Col md="2">
                <h5>Legal</h5>
                <ul className="links-vertical">
                  <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Transactions FAQ
                    </a>
                  </li>
                  <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Terms &amp; Conditions
                    </a>
                  </li>
                  <li>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      Licenses
                    </a>
                  </li>
                </ul>
              </Col>
              <Col md="3">
                <h5>Subscribe to Newsletter</h5>
                <p>
                Join our newsletter and get news about NFTs, Web3 art, and live metaverse events.
                </p>
                <Form action="" className="form form-newsletter" method="">
                  <FormGroup>
                    <Input placeholder="Your Email..." type="email"></Input>
                  </FormGroup>
                  <Button
                    className="btn-icon btn-round"
                    color="info"
                    name="button"
                    type="button"
                  >
                    <i className="now-ui-icons ui-1_email-85"></i>
                  </Button>
                </Form>
              </Col>
            </Row>
          </div>
          <hr></hr>
          <ul className="social-buttons">
            <li>
              <Button
                className="btn-icon btn-neutral mr-1"
                color="twitter"
                href="https://twitter.com/tenfinney" target="_blank"
                size="lg"
              >
                <i className="fab fa-twitter"></i>
              </Button>
            </li>
            <li>
              <Button
                className="btn-icon btn-neutral"
                color="youtube"
                href="https://ipfs.infura.io/ipfs/QmRu3UCuioKp3SayzNvq6MHxLqWu26by3sQqvzHEn3mWXU" target="_blank"
                size="lg"
              >
                <i className="fab fa-youtube"></i>
              </Button>
            </li>
          </ul>
          <div className="copyright pull-center" id="copyright">
            Copyright © {new Date().getFullYear()} Scott Stevenson All Rights
            Reserved.
          </div>
        </Container>
      </footer>
    </>
  );
}

export default FooterSocial;
